import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";


export const keys = {
    all: ["custom-form-instances"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    list: (
        customerID:  number,
        groupID: number,
        objectID: number,
        objectType: eLynxObjectTypeEnum,
        offline: boolean,
        startTime: Date | undefined,
        endTime: Date | undefined
        //sessionToken: string | undefined
        
) => [
        ...keys.lists(),
         {
            customerID,
            groupID,
            objectID,
            objectType,
            offline,
            startTime,
            endTime,
            //sessionToken
        }
    ],
};
